import React from 'react';
import PropTypes from 'prop-types';
import './ActionButton.scss';

export class ActionButton extends React.Component{
    render(){
        const { props } = this;
        return(
            <button className="action-button" {...props} >
                {props.children}
            </button>
        )
    }
}
ActionButton.propTypes = {
  children: PropTypes.node,
}


// WEBPACK FOOTER //
// ./src/shared/components/ActionButton.js